export const LOCAL_STORAGE = {
  // change BOILER_PLATE_ into app name
  BOILER_PLATE_LANGUAGE: 'BOILER_PLATE_LANGUAGE',
  OAUTH_BACK_OFFICE_ACCESS_TOKEN: 'OAUTH_BACK_OFFICE_ACCESS_TOKEN',
}